'use strict';

function replaceCOutsideStrings(code,varname,varvalue) {
    const stringRegex = /"(?:\\.|[^"\\])*"/g; 
    const placeholders = [];
    let i = 0;

    const codeWithoutStrings = code.replace(stringRegex, match => {
        const key = `___STR_PLACEHOLDER_${i}___`;
        placeholders.push({ key, value: match });
        i++;
        return key;
    });

    // Paso 2: reemplazar "c" solo fuera de strings
    //const replaced = codeWithoutStrings.replace(/(?<![a-zA-ZÀ-ÿ0-9_])c(?![a-zA-ZÀ-ÿ0-9])/g, varvalue);

    let regex = new RegExp('(?<![a-zA-ZÀ-ÿ-0-9])' + varname + '(?![a-zA-ZÀ-ÿ])', 'gu');
    const replaced = codeWithoutStrings.replace(regex, varvalue);

    // Paso 3: restaurar los strings originales
    const finalCode = placeholders.reduce(
        (acc, { key, value }) => acc.replace(key, value),
        replaced
    );

    return finalCode;
}

var formulaValidateCtrl = ['$state', '$scope', 'toast', function ($state, $scope, toast) {
    var _this = this;
    this.model = '';
    this.modelToDisplay = '';
    this.error = "N/A";
    _this.field.templateData.maxDecimalsCount = _this.field.templateData.maxDecimalsCount ?? _this.field.templateData.formula?.decimals;
    this.returnTestValue = function (formulaData, letter) {
        return formulaData.variables.filter(function (v) {
            return v.variable === letter;
        })[0].testValue || 0;
    };

    this.returnFormValue = function (variable) {
        if (
            variable.dataSource?.id &&
            _this.formPayload &&
            _this.formPayload[variable.dataSource.id] &&
            (_this.formPayload[variable.dataSource.id].value != undefined)
        ) {
            return _this.formPayload[variable.dataSource.id].value;
        } else if (
            variable.dataSource?.id &&
            _this.completeModel &&
            _this.completeModel[variable.dataSource.id] &&
            (_this.completeModel[variable.dataSource.id].value != undefined)
        ) {
            return _this.completeModel[variable.dataSource.id].value;
        } else if (
            variable.dataSource?.id &&
            _this.validatePayload &&
            _this.validatePayload[variable.dataSource.id] &&
            (_this.validatePayload[variable.dataSource.id].value != undefined)
        ) {
            return _this.validatePayload[variable.dataSource.id].value;
        } else {
            return null; // null -> error
        }
    };
    

    this.executeFormula = function (formulaData, variables, decimals) {
        let compiledFormula = formulaData.formula;

        for (let i = 0; i < variables.length; i++) {
            let value = _this.returnFormValue(variables[i])

            if (value === null) {
                _this.model = ''
                _this.modelToDisplay = "";
                return;
            }

            const regex = new RegExp(variables[i].variable, 'g');
            compiledFormula = compiledFormula.replace(regex, "(".concat(value, ")"));
        }

        try {
            var result = eval(compiledFormula);
            if (decimals && !isNaN(decimals))
                result = result.toFixed(decimals)
            _this.model = result;
            _this.modelToDisplay = maskValue(result,_this.field);
            return;
        } catch (e) {
            _this.model = '';
            this.modelToDisplay = '';
            return;
        }
    };

    this.executeFormulaAdvanced = function (formulaData, variables) {
        return new Promise((resolve, reject) => {
            if (!formulaData.formula) {
                reject('No formula provided');
                return;
            }

            let compiledFormula = formulaData.formula;
            let variableNames = [];
            let variableValues = [];

            // Function to convert all values to strings if any variable is not numeric
            const convertValuesNumber = () => {
                return new Promise((resolve) => {
                    for (let i = 0; i < variables.length; i++) {
                        let value = _this.returnFormValue(variables[i]);
                        value = JSON.stringify(value);
                        variableNames.push(variables[i].variable);
                        variableValues.push(value);
                    }
                    resolve();
                });
            };

            // Function to replace the variables in the formula with the corresponding values
            const replaceVariables = () => {
                return new Promise((resolve) => {
                    for (let i = 0; i < variableNames.length; i++) {
                        //let regex = new RegExp('(?<![a-zA-ZÀ-ÿ-0-9])' + variableNames[i] + '(?![a-zA-ZÀ-ÿ])', 'gu');
                        compiledFormula = replaceCOutsideStrings(compiledFormula, variableNames[i],variableValues[i]); 
                        // compiledFormula.replace(regex, variableValues[i]);
                    }
                    resolve();
                });
            };

            // Execute the functions sequentially
            convertValuesNumber()
                .then(replaceVariables)
                .then(() => {
                    try {
                        if (!compiledFormula.includes("return ")) {
                            compiledFormula = `return (${compiledFormula})`;
                        }
                        let result = eval(`(function (){${compiledFormula}})()`);

                        resolve(result);
                    } catch (e) {
                        console.error("formulaDirective", _this.field.name,_this.field.id);
                        console.log("Error in formula:", e);
                        //console.log(compiledFormula);
                        reject('error');
                    }
                });
        });
    };

    this.calculateFormulaAdvanced = function () {
        // console.log('calculateFormulaAdvanced this.field', this.field)
        const formulaData = this.field?.templateData?.formulaAdvanced;
        const variables = this.field?.templateData?.formulaAdvanced?.variables;

        if (formulaData && variables) {
            this.executeFormulaAdvanced(formulaData, variables)
                .then(result => {
                    this.model = result;
                    this.modelToDisplay = maskValue(result,_this.field);
                    $scope.$apply(); // Ensure that Angular updates the view
                })
                .catch((e) => {
                    this.model = '';
                    this.modelToDisplay = "";
                    this.error = e;
                    $scope.$apply(); // Ensure that Angular updates the view
                });
        }
    };

    // Calculate Formula Result
    if (this.field.type == 'formula') {
        if (this.field?.templateData?.isAdvanced) {
            // Advanced
            _this.calculateFormulaAdvanced()
        } else {
            // not Advanced
            _this.executeFormula(_this.field.templateData.formula, _this.field.templateData.formula.variables, _this.field.templateData.formula.decimals);
        }
    }

    $scope.$watch("ctrl.completeModel", function (newValue, oldValue) {
        if (newValue === oldValue)
            return;

        let hasChanges = false;
        Object.keys(newValue).forEach((key) => {
            const newVal = newValue[key]?.value;
            const oldVal = oldValue[key]?.value;

            if (newVal != oldVal) {
                hasChanges = true;
            }
        });

        if (hasChanges) {
            if (_this.field.type == 'formula' && _this.field?.templateData?.isAdvanced) {
                _this.calculateFormulaAdvanced()
            }

        }
    }, true);
}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            field: '=',
            formPayload: '=',
            model: '=',
            completeModel: "=",
            validatePayload: '=',
        },
        controller: formulaValidateCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'directives/formulaValidateDirective.html'
    };
};
